import { IconType } from '../Icon/Icon';

export enum DropDownListItemStatus {
  ERROR = 'error',
  WARNING = 'warning',
  DEFAULT = 'default',
}

export type DropdownListItem = {
  /**
   * The unique value associated with the dropdown item.
   * This value is used internally to identify the item.
   */
  value: string;

  /**
   * The text or ReactNode to display for the dropdown item.
   * If not provided, `value` can be used as a fallback for display.
   */
  displayValue?: string | React.ReactNode;

  /**
   * Determines whether the dropdown item is disabled.
   * A disabled item cannot be selected and appears visually distinct.
   */
  disabled?: boolean;

  /**
   * The icon name or identifier to display alongside the item.
   */
  icon?: IconType;

  /**
   * Indicates whether the item is a divider.
   * Dividers are non-interactive and used to visually separate groups of items.
   */
  divider?: boolean;

  /**
   * @prop {DropDownListItemStatus | undefined} status - the status of the entry
   * @default 'default'
   */
  status?: DropDownListItemStatus;

  /**
   * The icon name or identifier to display alongside the item.
   */
  actionButtonIcon?: IconType;
};
